"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FileUploadPopover_module_scss_1 = __importDefault(require("./FileUploadPopover.module.scss"));
const PopoverSharedStyle_module_scss_1 = __importDefault(require("./PopoverSharedStyle.module.scss"));
const react_popper_1 = require("react-popper");
const react_dropzone_1 = require("react-dropzone");
const react_i18next_1 = require("react-i18next");
const feed_factory_loader_1 = __importDefault(require("@feed-factory/feed-factory.loader"));
const feed_factory_helpers_1 = require("@feed-factory/feed-factory.helpers");
const FileUploadPopover = ({ children, onFilesSubmit, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [popoverActive, setPopoverActive] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const onDrop = (0, react_1.useCallback)((acceptedFiles, rejectedFiles) => {
        if (acceptedFiles.length < 1) {
            alert(t("form.unsupportedFileType"));
            return;
        }
        setIsLoading(true);
        (0, feed_factory_helpers_1.postAssets)(acceptedFiles).then((res) => {
            const onlyUri = res.map((item) => {
                return item.uri;
            });
            setIsLoading(false);
            setPopoverActive(false);
            onFilesSubmit(onlyUri);
        });
    }, [onFilesSubmit, setPopoverActive, t]);
    const { getRootProps, getInputProps } = (0, react_dropzone_1.useDropzone)({
        onDrop,
        accept: "image/jpeg, image/png",
        maxSize: 10485760,
    });
    const [popperOrigin, registerPopperOrigin] = (0, react_1.useState)(null);
    const [popperElement, setPopperElement] = (0, react_1.useState)(null);
    const { styles, attributes } = (0, react_popper_1.usePopper)(popperOrigin, popperElement, {});
    const onButtonClickHandler = () => {
        setPopoverActive(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children(registerPopperOrigin, onButtonClickHandler),
        react_1.default.createElement("div", Object.assign({ className: [
                PopoverSharedStyle_module_scss_1.default.popover,
                FileUploadPopover_module_scss_1.default.popover,
                popoverActive ? PopoverSharedStyle_module_scss_1.default.active : "",
            ].join(" "), ref: setPopperElement, style: styles.popper }, attributes.popper),
            react_1.default.createElement("div", Object.assign({ className: isLoading ? "isHidden" : "" }, getRootProps()),
                react_1.default.createElement("input", Object.assign({}, getInputProps())),
                react_1.default.createElement("p", null, t("form.uploadImage")),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("em", null, t("form.uploadImageTypes")))),
            react_1.default.createElement("div", { className: [FileUploadPopover_module_scss_1.default.loader, !isLoading ? "isHidden" : ""].join(" ") },
                react_1.default.createElement(feed_factory_loader_1.default, null),
                react_1.default.createElement("p", null, t("form.uploading")))),
        react_1.default.createElement("div", { className: `${PopoverSharedStyle_module_scss_1.default.backdrop} ${popoverActive ? PopoverSharedStyle_module_scss_1.default.active : ""}`, onClick: () => {
                setPopoverActive(false);
            } })));
};
exports.default = FileUploadPopover;
//# sourceMappingURL=FileUploadPopover.js.map